// Guías de Aprender · Primeros pasos (reescritas el 2026-10-18 a partir de las reglas oficiales,
// el libro «Cómo llegar a la Xima» y el motor del juego).

export const PRIMEROS_GUIDES = [
  {
    slug: "que-es-xima",
    theme: "primeros-pasos",
    nav: "Qué es XIMA",
    title: "Qué es XIMA: el juego de mesa de estrategia en 3D",
    description:
      "XIMA es un juego de mesa cubano en 3D: una pirámide de 4 pisos, 10 bloques por jugador y una meta, llevar tu bloque especial a la cima. Juega gratis online.",
    h1: "Qué es XIMA",
    intro:
      "XIMA es un juego de mesa de estrategia que se juega hacia arriba. El tablero es una pirámide escalonada de cuatro pisos y gana quien lleve primero su bloque especial a la casilla más alta, la cima (G7). Se puede jugar sin azar, como el ajedrez, o con dados, como el parchís.",
    sections: [
      {
        h: "Un juego que se juega en tres dimensiones",
        p: [
          "En casi todos los juegos de mesa las piezas se mueven sobre un plano. En XIMA, además de avanzar por el tablero, los bloques suben y bajan de piso. Visto desde arriba, el tablero tiene 13 × 13 casillas (169 en total); visto de lado, es una pirámide con cuatro pisos, y en lo más alto hay una sola casilla: la cima.",
          "Para subir no basta con querer: hace falta apoyarse en otro bloque, propio o contrario, que haga de escalón. Por eso cada partida es una carrera por construir caminos hacia arriba y, al mismo tiempo, por cortar los caminos del rival.",
        ],
        figure: "tablero-vista-superior",
      },
      {
        h: "Las piezas: diez bloques iguales",
        p: [
          "Cada jugador tiene 10 bloques de su color: nueve bloques comunes y un bloque especial. Todos se mueven igual, en línea recta y en cualquier dirección. La diferencia es la misión: solo el bloque especial puede ganar la partida llegando a la cima.",
          "Al empezar, todos los bloques están fuera del tablero. En cada turno eliges entre meter un bloque nuevo (incorporar) o mover uno de los que ya tienes dentro.",
        ],
      },
      {
        h: "Dominar y capturar",
        p: [
          "Cuando un bloque termina su movimiento encima de otro, lo domina: el de abajo ya no se puede mover mientras siga tapado. Si en esa columna un color queda en minoría frente al que acaba de llegar, esos bloques se capturan y salen del juego.",
          "Capturar no es el objetivo, pero ayuda: quita escalones al rival y abre camino a los tuyos.",
        ],
      },
      {
        h: "Con azar, sin azar o las dos cosas",
        p: [
          "XIMA tiene cuatro modos. En Ciencia no hay dados: decides cada movimiento. En Azar lanzas dos dados y mueves los pasos que salen. En Cienzar, en cada turno eliges si juegas libre o lanzas los dados. En Ciencia V/S Azar (también llamado Contrazar) un bando juega sin dados y el otro con dados.",
          "Esa mezcla de ciencia y azar es la que da nombre a Cienzar, un género de juego que el libro de XIMA presenta como nuevo: ni puro cálculo ni pura suerte.",
        ],
      },
      {
        h: "No hay empates",
        p: [
          "XIMA está pensada para que siempre haya un ganador. Si la partida se estanca, no se firman tablas: se pide incremento de material y cada jugador recibe tres bloques comunes más para seguir jugando.",
        ],
      },
      {
        h: "Dónde jugar",
        p: [
          "Puedes jugar gratis en juegoxima.com desde el ordenador o el móvil: contra otras personas, contra el bot en cuatro niveles de dificultad, en torneos, con amigos o resolviendo puzzles. No hace falta instalar nada; en Android también puedes descargar la app desde el menú.",
        ],
      },
    ],
    facts: [
      ["Jugadores", "2 a 4 (1 contra 1, 1 contra 2 o 1 contra 3)"],
      ["Tablero", "Pirámide de 4 pisos, 13 × 13 casillas"],
      ["Piezas", "10 bloques por jugador: 9 comunes y 1 especial"],
      ["Objetivo", "Llevar el bloque especial a la cima (G7)"],
      ["Modos", "Ciencia, Azar, Cienzar y Ciencia V/S Azar"],
      ["Origen", "Cuba, 2010"],
    ],
    video: "NlSq0nlnHYM",
    faqs: [
      ["¿Cuál es el objetivo de XIMA?", "Llevar tu bloque especial a la cima del tablero, la casilla G7, con una jugada legal. El primero que lo consigue gana."],
      ["¿XIMA es un juego de suerte?", "Depende del modo. En Modo Ciencia no hay ningún dado y gana quien juega mejor. En Modo Azar los dados marcan los pasos. En Cienzar cada jugador decide en su turno si usa los dados o no."],
      ["¿Es difícil de aprender?", "No. Todos los bloques se mueven igual, así que en unos minutos puedes jugar tu primera partida. Lo que lleva tiempo es aprender a subir rápido y a frenar al rival."],
      ["¿Quién inventó XIMA?", "XIMA se creó en La Habana, Cuba, en 2010. Sus autores son Yosdel Vicente Muiño Acevedo y Liz Power Suárez."],
      ["¿Se puede jugar gratis?", "Sí. Puedes jugar gratis en juegoxima.com. Premium es opcional y añade análisis y videos de partidas sin límite."],
    ],
    related: ["como-jugar", "reglas", "reglas/tablero-y-casillas", "modos-de-juego", "historia-de-xima"],
    cta: { label: "Aprende a jugar", slug: "como-jugar" },
    en: "en/what-is-xima",
  },
  {
    slug: "como-jugar",
    theme: "primeros-pasos",
    nav: "Cómo jugar",
    title: "Cómo jugar XIMA: guía para tu primera partida",
    description:
      "Aprende a jugar XIMA en 5 minutos: cómo entrar bloques, moverlos en línea recta, subir de piso apoyándote en otros y llevar tu bloque especial a la cima.",
    h1: "Cómo jugar XIMA",
    intro:
      "Esta guía te enseña lo justo para jugar tu primera partida: qué tienes que conseguir, qué puedes hacer en tu turno y cómo se sube a la cima. Las reglas completas están en la guía de Reglas.",
    sections: [
      {
        h: "1. La meta",
        p: [
          "Gana quien lleve primero su bloque especial a la cima, la casilla G7 en lo más alto de la pirámide. Todo lo demás (dominar, capturar, bloquear) sirve para acercarte tú o para frenar al rival.",
        ],
      },
      {
        h: "2. Tu turno: entrar o mover",
        p: [
          "Empiezas con tus 10 bloques fuera del tablero. En cada turno haces una sola de estas dos cosas:",
        ],
        list: [
          "Incorporar: meter en el tablero un bloque que tienes fuera. Entra por el borde de la pirámide, avanzando de frente o en diagonal, y no puede empezar ni terminar encima de otro bloque.",
          "Mover: desplazar uno de tus bloques que ya está dentro, en línea recta (horizontal, vertical o diagonal) y tantas casillas como quieras.",
        ],
        figure: "incorporar-bloque",
      },
      {
        h: "3. Cómo se sube de piso",
        p: [
          "Cada piso de la pirámide está dos alturas de bloque por encima del anterior. Un bloque solo puede subir, en cada paso, la altura de un bloque. Por eso, para pasar al piso de arriba necesitas un escalón: un bloque (tuyo o del rival) pegado al piso superior por el que puedas pasar.",
          "Ejemplo: tienes un bloque en A1 y otro en B2. El de A1 puede moverse en diagonal pasando por encima de B2 y llegar a C3, que ya es el segundo piso. B2 ha hecho de escalón. Bajar, en cambio, se puede siempre.",
        ],
        figure: "subir-con-escalon",
      },
      {
        h: "4. Dominar y capturar",
        p: [
          "Si terminas tu movimiento encima de un bloque, lo dominas: queda inmovilizado mientras lo tapes. Si con tu llegada tu color es mayoría en esa columna, los bloques de los colores que quedan en minoría se capturan y salen del juego.",
          "Ejemplo: en una casilla hay un bloque rojo con uno azul encima (el rojo está dominado, pero no capturado: 1 contra 1). Si otro bloque azul llega a esa casilla desde más arriba, los azules son 2 contra 1 y el rojo se captura.",
        ],
      },
      {
        h: "5. El bloque especial",
        p: [
          "Tu bloque especial se mueve como los demás, pero tiene dos reglas propias: nunca puede subir ni pasar por encima del especial contrario, y es el único que gana al llegar a la cima. Si te lo capturan no pierdes: puedes rescatarlo llevando un bloque común a la cima.",
          "Un consejo del libro de XIMA: no lo metas al principio. Prepara antes el camino con tus bloques comunes y métalo cuando pueda entrar alto y protegido.",
        ],
      },
      {
        h: "6. Tu primera partida",
        p: [
          "Lo más fácil es empezar contra el bot en dificultad Fácil y en Modo Ciencia, sin dados, para fijarte solo en el tablero. Cuando termines, abre la repetición desde Historial y mira en qué momento el rival subió antes que tú.",
        ],
      },
    ],
    steps: {
      title: "Resumen en 6 pasos",
      items: [
        "Mira el tablero: cuatro pisos y la cima en G7.",
        "En tu turno, incorpora un bloque o mueve uno que ya esté dentro.",
        "Mueve siempre en línea recta y sin salir del tablero.",
        "Para subir de piso, pasa por encima de un bloque que haga de escalón.",
        "Domina bloques rivales poniéndote encima y captúralos cuando seas mayoría en la columna.",
        "Mete tu bloque especial cuando tenga camino y llévalo a G7.",
      ],
    },
    video: "NlSq0nlnHYM",
    faqs: [
      ["¿Qué hago en mi primer turno?", "Incorpora un bloque común. Una buena primera jugada es entrar cerca de una esquina o del centro de una cara para preparar un escalón hacia el segundo piso."],
      ["¿Cuántas casillas puede moverse un bloque?", "En Modo Ciencia, las que quieras en línea recta, mientras el camino lo permita. En Modo Azar, exactamente las que marca el dado."],
      ["¿Puedo sacar un bloque del tablero?", "No. Una vez dentro, un bloque solo sale si lo capturan."],
      ["¿Necesito saberme todas las reglas para empezar?", "No. Con la meta, el turno y la forma de subir ya puedes jugar. Lo demás lo aprenderás partida a partida."],
    ],
    related: ["reglas", "reglas/subir-bloques", "reglas/dominacion-y-captura", "bots", "tutoriales/crear-partida"],
    cta: { label: "Juega contra el bot", slug: "bots" },
    en: "en/how-to-play",
  },
  {
    slug: "historia-de-xima",
    theme: "primeros-pasos",
    nav: "Historia de XIMA",
    title: "Historia de XIMA: el juego de mesa creado en Cuba",
    description:
      "XIMA nació en La Habana en 2010, creado por Yosdel Vicente Muiño Acevedo y Liz Power Suárez. Conoce de dónde viene el juego, su nombre y su idea.",
    h1: "Historia de XIMA",
    intro:
      "XIMA nació en La Habana, Cuba, en 2010. La crearon Yosdel Vicente Muiño Acevedo y Liz Power Suárez con una idea muy simple de decir y muy difícil de hacer: un juego de mesa que se jugara hacia arriba.",
    sections: [
      {
        h: "Una promesa de amor",
        p: [
          "Según cuenta el libro «Cómo llegar a la Xima», el juego surgió de una promesa: regalarle a Liz el mejor juego de mesa posible, uno que les permitiera pasar más tiempo juntos, en casa y en familia. Tardaron unos doce años en darle su forma definitiva.",
        ],
      },
      {
        h: "Del ajedrez a la pirámide",
        p: [
          "Antes de XIMA, Yosdel escribió un cuento infantil llamado «El rey peón», en el que las piezas del ajedrez cobran vida. Para escribirlo tuvo que imaginar cómo se habría inventado el ajedrez, y de ese ejercicio salió la pregunta que lo cambió todo: ¿y si el tablero no fuera plano?",
          "Buscaban un tablero original y misterioso, y no encontraron misterio mayor que el de las pirámides. Las primeras pruebas se hicieron con una pirámide de dados de cubilete guardada en una caja de zapatos. También se probaron piezas de ajedrez antes de llegar a los bloques, que se llaman así porque de bloques están hechas las pirámides.",
          "El movimiento en línea recta en ocho direcciones viene de un juego anterior de Yosdel, el «360 grados», en el que un dado marcaba los puntos cardinales y otro los pasos.",
        ],
      },
      {
        h: "De Cima a Xima",
        p: [
          "Al principio el juego se llamaba Cima, por su objetivo: llegar a lo más alto. Con el tiempo pasó a escribirse XIMA. Por eso en el juego la casilla más alta se sigue llamando cima, y a quien juega y estudia XIMA el libro lo llama «cimista».",
        ],
      },
      {
        h: "Un objetivo pacífico",
        p: [
          "En XIMA no se gana destruyendo al rival, sino construyendo un camino. Los bloques no representan ejércitos, reyes ni clases sociales: son cubos iguales que se combinan para subir. Esa idea, ganar construyendo, es el mensaje que sus autores quisieron dejar.",
        ],
      },
      {
        h: "Un nuevo género: Cienzar",
        p: [
          "Como XIMA se puede jugar con y sin dados, no encaja del todo ni en los juegos de azar ni en los de pura estrategia. El libro propone para ella una categoría nueva, Cienzar (ciencia + azar), que también da nombre a uno de los modos de juego.",
        ],
      },
      {
        h: "Nombres de la familia en el tablero",
        p: [
          "Las aperturas de XIMA llevan nombres de personas y lugares importantes para sus autores: Liz, Susy (dedicada a la madre de Yosdel), Muiño (a su padre), Yosdel (por su hijo Ledsoy, que es su nombre al revés), Párragueña (por su pueblo natal), Capablanca (por el campeón cubano de ajedrez) y Tanu o ucraniana. La maniobra Zil se llama así por Liz, leído al revés.",
        ],
      },
      {
        h: "XIMA hoy",
        p: [
          "Hoy XIMA se juega online en juegoxima.com, con partidas en vivo, bots, torneos, campeonatos, puzzles, repeticiones con análisis y una puntuación propia, el CIMAX, para medir el nivel de cada jugador.",
        ],
      },
    ],
    faqs: [
      ["¿Dónde se inventó XIMA?", "En La Habana, Cuba, en el año 2010."],
      ["¿Quiénes son los autores de XIMA?", "Yosdel Vicente Muiño Acevedo y Liz Power Suárez."],
      ["¿Por qué se llama XIMA?", "Viene de «cima», la casilla más alta del tablero, que es el objetivo del juego."],
      ["¿Hay un libro sobre XIMA?", "Sí: «Cómo llegar a la Xima», donde están las reglas, la notación, el CIMAX, las aperturas, las defensas y las maniobras. Puedes leerlo en la pestaña Libros de Aprender."],
    ],
    related: ["que-es-xima", "estrategia/aperturas-xima", "cienzar", "articulos/xima-y-el-ajedrez"],
    cta: { label: "Qué es XIMA", slug: "que-es-xima" },
    en: "en/history-of-xima",
  },
  {
    slug: "academia",
    theme: "primeros-pasos",
    nav: "Plan de estudio",
    title: "Plan de estudio de XIMA: de principiante a experto",
    description:
      "Una ruta ordenada para aprender XIMA: reglas básicas, primeras partidas, subir de piso, dominar, aperturas, medio juego y finales. Con guías y ejercicios.",
    h1: "Plan de estudio de XIMA",
    intro:
      "Si no sabes por dónde empezar, sigue este orden. Cada nivel te dice qué leer, qué practicar y cómo saber que ya puedes pasar al siguiente.",
    sections: [
      {
        h: "Nivel 1 · Aprender a jugar",
        p: ["Objetivo: jugar una partida completa sin dudas sobre las reglas."],
        list: [
          "Lee Qué es XIMA y Cómo jugar.",
          "Mira el video de cómo jugar de la pestaña Videos.",
          "Repasa El tablero y las casillas para saber dónde está cada piso.",
          "Juega tres partidas contra el bot en Fácil y en Modo Ciencia.",
        ],
      },
      {
        h: "Nivel 2 · Subir de piso",
        p: ["Objetivo: llegar al segundo piso antes que el bot."],
        list: [
          "Estudia Subir de piso y Bloqueo y obstrucción.",
          "Aprende Dominación y captura: cuándo se inmoviliza un bloque y cuándo se elimina.",
          "Practica la idea del escalón: mete un bloque en una casilla interior y sube otro por encima.",
          "Pasa a dificultad Medio cuando ganes con claridad en Fácil.",
        ],
      },
      {
        h: "Nivel 3 · Jugar con plan",
        p: ["Objetivo: tener una idea para cada fase de la partida."],
        list: [
          "Lee Aperturas y Defensas para saber por dónde entrar.",
          "Lee Medio juego: los centros, el espacio y la administración de bloques.",
          "Aprende la notación para poder apuntar y repasar tus partidas.",
          "Usa Analizar partida para ver qué jugadas te costaron la victoria.",
        ],
      },
      {
        h: "Nivel 4 · Ganar los finales",
        p: ["Objetivo: convertir en victoria una ventaja en la tercera planta."],
        list: [
          "Estudia Finales, la oposición del especial y Amenazas al especial.",
          "Aprende las maniobras Zil y Feedback.",
          "Resuelve un puzzle cada día: casi siempre se trata de llegar a la cima en pocas jugadas.",
          "Juega contra el bot en Difícil e Injusto y entra en torneos.",
        ],
      },
      {
        h: "Cómo estudiar mejor",
        p: [
          "El libro de XIMA recomienda estudiar los finales pronto, porque en ellos se ve con claridad qué hace falta para llegar a la cima, y eso da sentido a todo lo que haces antes. Repasa siempre tus derrotas en la repetición: casi siempre hay un momento concreto en que el rival subió y tú no lo frenaste.",
        ],
      },
    ],
    faqs: [
      ["¿Cuánto se tarda en aprender XIMA?", "Las reglas se aprenden en unos minutos. Jugar bien es otra cosa: como en el ajedrez, siempre se puede mejorar."],
      ["¿Qué modo es mejor para aprender?", "Modo Ciencia, porque no hay dados y cada resultado depende solo de tus decisiones."],
      ["¿Contra qué dificultad del bot empiezo?", "Fácil. Sube a Medio cuando ganes varias partidas seguidas."],
    ],
    related: ["como-jugar", "reglas", "estrategia", "puzzles", "analizar-partida"],
    cta: { label: "Empieza por el nivel 1", slug: "como-jugar" },
    legacy: [
      "academia/principiantes",
      "academia/intermedio",
      "academia/lecciones",
      "academia/ejercicios",
      "academia/analisis-partidas",
    ],
  },
  {
    slug: "glosario",
    theme: "primeros-pasos",
    nav: "Glosario",
    title: "Glosario de XIMA: todas las palabras del juego",
    description:
      "Qué significa cima, G7, dominar, capturar, escalón, banda, anillo, coordinar, oposición, Cienzar, CIMAX y el resto de términos de XIMA, explicado fácil.",
    h1: "Glosario de XIMA",
    intro:
      "Aquí tienes las palabras que vas a encontrar en las reglas, en las guías y en el libro de XIMA, ordenadas por tema. Muchas vienen del glosario original del libro «Cómo llegar a la Xima».",
    sections: [
      {
        h: "El tablero",
        defs: [
          ["Pirámide", "El tablero de XIMA: una pirámide escalonada de cuatro pisos."],
          ["Cima o G7", "La casilla más alta, el cuarto piso. Llegar a ella con el bloque especial da la victoria."],
          ["Piso o planta", "Cada nivel de la pirámide. Del primero (el más grande) al cuarto (la cima)."],
          ["Anillo", "Cada piso, salvo la cima, tiene dos anillos de casillas: el exterior (el borde) y el interior (el que está pegado al piso de arriba)."],
          ["Casillas interiores", "Las casillas pegadas al piso superior. Son las que sirven de escalón."],
          ["Banda", "Las dos hileras de casillas (exterior e interior) de una misma cara en un piso."],
          ["Cara", "Cada uno de los cuatro lados de la pirámide: A1-M1, M1-M13, M13-A13 y A13-A1."],
          ["Esquinas", "Exteriores: A1, M1, M13 y A13. Interiores: B2, L2, L12 y B12."],
          ["Centrales", "Las casillas de las líneas G1-G13 y A7-M7. Centrales exteriores: G1, M7, G13 y A7."],
          ["Diagonales superiores", "Las casillas de las diagonales A1-M13 y M1-A13, que suben en línea recta hacia la cima."],
          ["Centro medio y centro alto", "El segundo piso (centro medio) y el tercero (centro alto). Controlarlos es clave en el medio juego."],
        ],
      },
      {
        h: "Los bloques",
        defs: [
          ["Bloque", "Cada pieza del juego. Cada jugador tiene 10: 9 comunes y 1 especial."],
          ["Bloque especial", "El único que gana al llegar a la cima. No puede subir ni pasar sobre otro especial y se puede rescatar si lo capturan."],
          ["Bloque común", "Los otros nueve. Sirven para subir, dominar, capturar, bloquear y rescatar al especial."],
          ["Bloque escalón", "Un bloque que permite a otros subir de piso pasando por encima de él, aunque él mismo no pueda subir solo."],
          ["Bloque reserva", "Un bloque que se guarda fuera del tablero para usarlo al final de la partida."],
          ["Torre o columna", "Varios bloques apilados en la misma casilla."],
        ],
      },
      {
        h: "Las acciones",
        defs: [
          ["Incorporar", "Meter en el tablero un bloque que está fuera."],
          ["Paso", "Cada casilla que avanza un bloque."],
          ["Movimiento", "El recorrido de un bloque en línea recta y en una sola dirección durante un turno."],
          ["Dominar", "Terminar un movimiento encima de otro u otros bloques. Los de abajo no se pueden mover."],
          ["Capturar", "Eliminar del juego los bloques que quedan en minoría en una columna al dominarla."],
          ["Liberar", "Quitar un bloque de encima de otros para que vuelvan a moverse."],
          ["Doblar", "Poner un bloque propio encima de otro propio para ganar altura."],
          ["Alinear", "Colocar dos bloques en la misma fila, columna o diagonal."],
          ["Coordinar", "Tener dos o más bloques propios que pueden subirse uno sobre otro en el siguiente movimiento."],
          ["Semicoordinar", "Igual que coordinar, pero solo uno de los bloques puede subirse sobre el otro."],
          ["Crear escalera", "Colocar un bloque en una casilla interior para que otro pueda subir por él."],
          ["Rescatar o recuperar", "Llevar un bloque común a la cima para cambiarlo por tu especial capturado."],
          ["Sacrificar", "Entregar un bloque a cambio de tiempo, espacio o una mejor posición."],
          ["Desviar", "Obligar al rival a gastar más movimientos para conseguir lo que busca."],
          ["Clavar", "Dejar un bloque sin poder moverse porque, si se mueve, pierde algo más importante."],
        ],
      },
      {
        h: "Situaciones de la partida",
        defs: [
          ["Bloqueo", "Una estructura de bloques que impide subir o bajar entre pisos."],
          ["Obstrucción", "Una estructura que impide desplazarse dentro del mismo piso."],
          ["Oposición", "Los dos bloques especiales uno junto al otro, separados solo por un lado o un vértice de casilla."],
          ["Ahogado", "Cuando un jugador, en su turno, no tiene bloques fuera para incorporar y todos los suyos en el tablero están dominados. Ese jugador gana."],
          ["Sin recurso", "Cuando un jugador se queda sin bloques dentro y fuera del tablero. Pierde la partida."],
          ["Posición muerta", "Cuando ningún especial puede llegar ya a la cima con jugadas legales. Se resuelve con incremento de material."],
          ["Incremento de material", "En lugar de empate, cada jugador recibe tres bloques comunes extra."],
          ["Iniciativa", "Marcar el ritmo de la partida con amenazas que obligan al rival a responder."],
        ],
      },
      {
        h: "Modos, puntuación y comunidad",
        defs: [
          ["Ciencia", "Modo sin dados: decides tú cada movimiento."],
          ["Azar", "Modo con dos dados que marcan los pasos."],
          ["Cienzar", "Modo híbrido: en cada turno eliges jugar libre o lanzar los dados. También es el nombre del género ciencia + azar."],
          ["Ciencia V/S Azar o Contrazar", "Modo en el que un bando juega sin dados y el otro con dados."],
          ["FreeBox", "Caja de arena para practicar movimientos libremente."],
          ["CIMAX", "La puntuación de nivel de XIMA. Cada jugador empieza con 1000."],
          ["Cimista", "Persona que juega, estudia o ama XIMA."],
        ],
      },
    ],
    related: ["reglas", "reglas/tablero-y-casillas", "reglas/dominacion-y-captura", "estadisticas/cimax"],
    cta: { label: "Ver las reglas", slug: "reglas" },
    legacy: [
      "diccionario",
      "diccionario/estrategia",
      "diccionario/tactica",
      "diccionario/planificacion",
      "diccionario/anticipacion",
      "diccionario/riesgo",
      "diccionario/probabilidad",
      "diccionario/toma-de-decisiones",
      "diccionario/pensamiento-logico",
      "diccionario/ataque",
      "diccionario/defensa",
      "diccionario/ventaja",
      "diccionario/posicion",
      "diccionario/movimiento",
      "diccionario/objetivo",
      "diccionario/error",
      "diccionario/analisis",
      "glosario/replay",
    ],
  },
  {
    slug: "preguntas-frecuentes",
    theme: "primeros-pasos",
    nav: "Preguntas frecuentes",
    title: "Preguntas frecuentes sobre XIMA",
    description:
      "Respuestas rápidas sobre XIMA: si es gratis, cuántos juegan, si hay app, cómo se gana, qué pasa si me capturan el especial y cómo funciona Premium.",
    h1: "Preguntas frecuentes",
    intro: "Las dudas más comunes sobre el juego y la web, con respuestas cortas y enlaces a la guía donde se explica cada tema a fondo.",
    sections: [
      {
        h: "Sobre el juego",
        qa: [
          ["¿Qué es XIMA?", "Un juego de mesa de estrategia en 3D. El tablero es una pirámide de cuatro pisos y gana quien lleve primero su bloque especial a la cima."],
          ["¿Cuántas personas pueden jugar?", "De 2 a 4. En la web puedes jugar 1 contra 1, 1 contra 2 o 1 contra 3, contra personas o bots."],
          ["¿Cuánto dura una partida?", "Depende del tiempo por turno que elijas (1, 2, 5 o 10 minutos), del número de jugadores y de lo rápido que se llegue a la cima."],
          ["¿Puede haber empate?", "No. Si la partida se estanca, cada jugador recibe tres bloques comunes más y se sigue jugando hasta que alguien gane."],
          ["¿Qué pasa si me capturan el bloque especial?", "No pierdes. Puedes rescatarlo llevando uno de tus bloques comunes a la cima; luego vuelves a meter el especial cuando quieras."],
          ["¿Se puede ganar sin el bloque especial?", "Llegando a la cima, no: solo el especial gana así. Pero también gana quien queda ahogado (sin bloques fuera y con todos los suyos dominados) y pierde quien se queda sin ningún bloque."],
        ],
      },
      {
        h: "Sobre la web",
        qa: [
          ["¿Es gratis jugar?", "Sí. Puedes jugar gratis. Premium es opcional."],
          ["¿Necesito registrarme?", "Para guardar tu historial, tus estadísticas y tu CIMAX, sí. También puedes entrar como invitado con un enlace que te pase un amigo."],
          ["¿Hay app para el móvil?", "La web funciona en el navegador del móvil. En Android también puedes descargar la app desde la opción Descargar app móvil del menú."],
          ["¿Qué incluye Premium?", "Análisis de partidas con el bot y descarga de videos de tus partidas sin límite, y todos los puzzles que quieras. Cuesta 2 USD al mes y se paga con PayPal."],
          ["¿Puedo jugar con amigos?", "Sí. Desde Amigos puedes buscarlos por su código de jugador, invitarlos a una partida o retarlos."],
          ["¿En qué idiomas está XIMA?", "Español, inglés, ruso y alemán. Se cambia en Ajustes."],
        ],
      },
    ],
    related: ["que-es-xima", "como-jugar", "premium", "cuenta", "soporte"],
    cta: { label: "Aprende a jugar", slug: "como-jugar" },
  },
];
